export default __webpack_public_path__ + "static/media/conqueror_white_icon.cde1fc9e.png";